import { useTranslation } from '../../i18n/i18n';
import { DeliveryAddressModel } from './DeliveryAddressInput';
import { Select } from '../Select/Select';
import { renderValue } from './utils';

type SelectLastAddressesInputProps = {
	selectedAddress: string;
	onSelectAddress: (e: any) => void;
	deliveryAddresses: DeliveryAddressModel[];
};

export const SelectLastAddressesInput = ({
	onSelectAddress,
	selectedAddress,
	deliveryAddresses,
}: SelectLastAddressesInputProps): JSX.Element => {
	const t = useTranslation().form;

	if (!deliveryAddresses || deliveryAddresses.length <= 1) return <></>;

	return (
		<Select
			list={deliveryAddresses}
			value={selectedAddress}
			renderValue={renderValue}
			placeholder={t.pickFromPreviouslyUsedAddresses}
			size="large"
			onSelect={onSelectAddress}
			nullValue={t.newAddress}
			idField="id"
			searchValue={(query: string, al: any[]) => al.find((s) => s.id.toString() == query)}
		/>
	);
};
